import DashboardNavbar from "../../../Components/Navbars/DashboardNavbar";
import DashboardLayout from "../../../Components/LayoutContainers/DashboardLayout";
import {setLoading, useMaterialUIController} from "../../../Context/mui";
import React, {useEffect, useLayoutEffect, useMemo, useState} from "react";
import {useFormik} from "formik";
import MDBox from "../../../Components/MDBox";
import {ButtonBase, Grid} from "@mui/material";
import MDInput from "../../../Components/MDInput";
import MDSelect from "../../../Components/MDSelect";
import MDDate from "../../../Components/MDDate";
import MDTypography from "../../../Components/MDTypography";
import Icon from "@mui/material/Icon";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import IconButton from "@mui/material/IconButton";
import {v4 as uuid} from 'uuid'
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import * as yup from 'yup';
import Cookies from "js-cookie";
import {ErrorToaast, SuccessToaast} from "../../..//utils/toast/Toast";
import {StudentSalamatModel} from "../../../Api/Model/SalamatModel";

const validationSchema = yup.object({

    Vaksan: yup.array().of(
        yup.object({
            id: yup.string().required(),
            VaksanKind: yup.string().required('نوع واکسن الزامی است'),
            VaksanDate: yup.date().required('تاریخ واکسن الزامی است'),
            VaksanAvarez: yup.string()
        })
    ),
    Daroo: yup.array().of(
        yup.object({
            id: yup.string().required(),
            DarooName: yup.string().required('نام دارو الزامی است'),
            DarooZaman: yup.string().required('زمان مصرف دارو الزامی است'),
            DarooGhat: yup.string().required('دلیل قطع مصرف دارو الزامی است'),
            DarooDoz: yup.string().required('دوز و تعداد دارو الزامی است')
        })
    ),
    Height: yup.number().required('قد الزامی است'),
    Weight: yup.number().required('وزن الزامی است'),
    Bmi: yup.number().required('شاخص توده بدنی الزامی است'),
    AzmayeshName: yup.string() ,
    AzmayeshDate: yup.date() ,
    AzmayeshResult: yup.string() ,
    AzmayeshDalil: yup.string() ,
    AzmayeshTafsir: yup.string() ,
    AzmayeshAlt: yup.number(),
    AzmayeshAST: yup.number(),
    AzmayeshGGT: yup.number(),
    PrevBimary: yup.string(),
    Hasasiat: yup.string(),
    Hdl: yup.number(),
    Triglycerides: yup.number(),
    TCholestrol: yup.number() ,
    Lholestrol: yup.number() ,
    BimaryHistory: yup.string() 
});

export default function SalamatStudent() {
    const [controller, dispatch] = useMaterialUIController();
    const [isNew, setIsnew] = useState(true)
    var Api = new StudentSalamatModel(Cookies.get("cst") ?? "");

    const {loading} = controller;

    const formik = useFormik({
        initialValues: {

            Vaksan: [],
            Daroo: [],
            Height: "",
            Weight: "",
            Bmi: "",
            AzmayeshName: "",
            AzmayeshDate: "",
            AzmayeshResult: "",
            AzmayeshDalil: "",
            AzmayeshTafsir: "",
            AzmayeshAlt: "",
            AzmayeshAST: "",
            AzmayeshGGT: "",
            PrevBimary: "",
            Hasasiat: "",
            Hdl: "",
            Triglycerides: "",
            TCholestrol: "",
            Lholestrol: "",
            BimaryHistory: ""
        },
        validationSchema: validationSchema,

        onSubmit: (values) => {

            Api.Create({

                Vaksan: values.Vaksan,
                Daroo: values.Daroo,
                Height: values.Height,
                Weight: values.Weight,
                Bmi: values.Bmi,
                AzmayeshName: values.AzmayeshName,
                AzmayeshDate: values.AzmayeshDate,
                AzmayeshResult: values.AzmayeshResult,
                AzmayeshDalil: values.AzmayeshDalil,
                AzmayeshTafsir: values.AzmayeshTafsir,
                AzmayeshAlt: values.AzmayeshAlt,
                AzmayeshAST: values.AzmayeshAST,
                AzmayeshGGT: values.AzmayeshGGT,
                PrevBimary: values.PrevBimary,
                Hasasiat: values.Hasasiat,
                Hdl: values.Hdl,
                Triglycerides: values.Triglycerides,
                TCholestrol: values.TCholestrol,
                Lholestrol: values.Lholestrol,
                BimaryHistory: values.BimaryHistory,
            }).then(response => {
                setLoading(dispatch, false)
                SuccessToaast("با موفقیت ویرایش شد")
            })
                .catch(error => {
                    ErrorToaast("خطا در ثبت اطلاعات");
                    setLoading(dispatch, false);
                });


        }
    })

    function addVaksan() {
        formik.setFieldValue("Vaksan", [...formik.values.Vaksan, {
            id: uuid(),
            VaksanKind: "",
            VaksanDate: "",
            VaksanAvarez: ""
        }])

    }


    function addDaroo() {
        formik.setFieldValue("Daroo", [...formik.values.Daroo, {
            id: uuid(),
            DarooName: "",
            DarooZaman: "",
            DarooGhat: "",
            DarooDoz: ""
        }])
    }

    useLayoutEffect(() => {
        setLoading(dispatch, true)
        Api.Get()
            .then(r => {
                if (r.data.data !== null) {
                    setIsnew(false)
                    let model = r.data.data;
                    formik.setValues({
                        Vaksan: model.vaksan.map(p => ({
                            id: p.id,
                            VaksanKind: p.vaksanKind,
                            VaksanDate: p.vaksanDate,
                            VaksanAvarez: p.vaksanAvarez
                        }),),
                        Daroo: model.daroo.map(p => ({
                            id: p.id,
                            DarooName: p.darooName,
                            DarooZaman: p.darooZaman,
                            DarooGhat: p.darooGhat,
                            DarooDoz: p.darooDoz,
                        }),),
                        Height: model.height,
                        Weight: model.weight,
                        Bmi: model.bmi,
                        AzmayeshName: model.azmayeshName,
                        AzmayeshDate: model.azmayeshDate,
                        AzmayeshResult: model.azmayeshResult,
                        AzmayeshDalil: model.azmayeshDalil,
                        AzmayeshTafsir: model.azmayeshTafsir,
                        AzmayeshAlt: model.azmayeshAlt,
                        AzmayeshAST: model.azmayeshAST,
                        AzmayeshGGT: model.azmayeshGGT,
                        PrevBimary: model.prevBimary,
                        Hasasiat: model.hasasiat,
                        Hdl: model.hdl,
                        Triglycerides: model.triglycerides,
                        TCholestrol: model.tCholestrol,
                        Lholestrol: model.lholestrol,
                        BimaryHistory: model.bimaryHistory

                    })
                }
                setLoading(dispatch, false)
            })
            .catch(r => {
                 if (r?.status == 404) {
                    setLoading(dispatch, false)

                    return
                }
                ErrorToaast("دریافت اطلاعات با مشکل مواجه شد")
                setLoading(dispatch, false)

            })

    }, [])
    useEffect(() => {
        let Bmi = formik.values.Weight / ((formik.values.Height / 100) * (formik.values.Height / 100))
        if (typeof Bmi == "number" && !isNaN(Bmi)) {
            formik.setFieldValue("Bmi", Bmi.toFixed(2))
        } else {
            formik.setFieldValue("Bmi", "0")
        }
    }, [formik.values.Height, formik.values.Weight])
    const calculatedValue = useMemo(() => {
        const bmi = parseFloat(formik?.values?.Bmi);

        if (isNaN(bmi)) {
            return { color: "#ccc", status: "بی‌ام‌آی نامعتبر" }; // Invalid BMI
        }

        if (bmi < 18.5) {
            return { color: "#1e90ff", status: "کم‌وزن" }; // Underweight
        } else if (bmi >= 18.5 && bmi < 24.9) {
            return { color: "#32cd32", status: "وزن نرمال" }; // Normal weight
        } else if (bmi >= 25 && bmi < 29.9) {
            return { color: "#ffa500", status: "اضافه وزن" }; // Overweight
        } else if (bmi >= 30 && bmi < 34.9) {
            return { color: "#ff4500", status: "چاقی (کلاس ۱)" }; // Obesity (Class 1)
        } else if (bmi >= 35 && bmi < 39.9) {
            return { color: "#ff0000", status: "چاقی (کلاس ۲)" }; // Obesity (Class 2)
        } else if (bmi >= 40) {
            return { color: "#8b0000", status: "چاقی مفرط (کلاس ۳)" }; // Extreme obesity (Class 3)
        }

        return { color: "#000000", status: "نا مشخص" }; // Fallback
    }, [formik?.values?.Bmi]);
    return <DashboardLayout>

        <DashboardNavbar name={"اطلاعات سلامت"}>
            اطلاعات سلامت
        </DashboardNavbar>
        {formik?.values?.Bmi && parseInt(formik?.values.Bmi) > 1 && (
            <MDBox py={3} bgColor="#fff" border={"1px solid darkblue"} p={1} mb={2} flex={1} borderRadius={2}
                   style={{overflowX: "auto", borderRadius: "10px"}}>
                <MDTypography fontWeight={"bold"}>
                    وضعیت bmi شما با توجه به وزن و قد <span style={{color: calculatedValue.color}}> {calculatedValue.status}</span> می باشد
                </MDTypography>
            </MDBox>
        )}
        <MDBox mx={{xs: 2, md: 10, lg: 10}} mt={4} component="form" role="form" onSubmit={formik.handleSubmit}>
            <Grid container rowSpacing={5} borderBottom={"1px solid #477B04"} py={4}>
                <Grid container item spacing={4}>
                    <Grid item xs={12} md={6} lg={4}>
                        <MDInput
                            id="Height"
                            name="Height"
                            value={formik.values.Height}
                            onChange={formik.handleChange}
                            error={
                                Boolean(formik.errors.Height)
                            }
                            helperText={formik.errors.Height}
                            autoComplete={"1"}
                            disabled={loading}
                            width={"200px"}
                            sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                            label={"قد"}/>
                    </Grid>
                    <Grid item xs={12} md={6} lg={4}>
                        <MDInput
                            id="Weight"
                            name="Weight"
                            value={formik.values.Weight}
                            onChange={formik.handleChange}
                            error={
                                Boolean(formik.errors.Weight)
                            }
                            helperText={formik.errors.Weight}
                            autoComplete={"1"}
                            disabled={loading}
                            width={"200px"}
                            sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                            label={"وزن"}/>
                    </Grid>
                    <Grid item xs={12} md={6} lg={4}>
                        <MDInput
                            id="Bmi"
                            name="Bmi"
                            value={formik.values.Bmi}
                            onChange={() => {
                            }}
                            error={
                                Boolean(formik.errors.Bmi)
                            }
                            helperText={formik.errors.Bmi}
                            autoComplete={"1"}
                            disabled={loading}
                            width={"200px"}
                            sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                            label={"شاخص توده بدنی (bmi)"}/>
                    </Grid>
                    <Grid item xs={12} md={12} lg={12}>
                        <MDTypography fontWeight={"bold"}>
                            نتایج آزمایشات
                        </MDTypography>
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <MDInput
                            id="AzmayeshName"
                            name="AzmayeshName"
                            value={formik.values.AzmayeshName}
                            onChange={formik.handleChange}
                            error={
                                Boolean(formik.errors.AzmayeshName)
                            }
                            helperText={formik.errors.AzmayeshName}
                            autoComplete={"1"}
                            disabled={loading}
                            width={"200px"}
                            sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                            label={"نوع آزمایش"}/>
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <MDDate
                            name="AzmayeshDate"
                            onChange={(r) =>
                                formik.setFieldValue("AzmayeshDate", r)
                            }
                            defaultValue={formik.values.AzmayeshDate}
                            label={("تاریخ آزمایش")}
                            error={
                                Boolean(formik.errors.AzmayeshDate)
                            }
                            portal
                            helperText={
                                formik.errors.AzmayeshDate
                            }
                            w={{xs: "100%", md: "100%", lg: "90%",}}

                            disabled={loading}
                        />
                    </Grid> <Grid item xs={12} md={6} lg={6}>
                    <MDInput
                        id="AzmayeshResult"
                        name="AzmayeshResult"
                        value={formik.values.AzmayeshResult}
                        onChange={formik.handleChange}
                        error={
                            Boolean(formik.errors.AzmayeshResult)
                        }
                        helperText={formik.errors.AzmayeshResult}
                        autoComplete={"1"}
                        disabled={loading}
                        width={"200px"}
                        sx={{width: {xs: "100%", md: "100%", lg: "96%",}}}
                        label={"نتیجه آزمایش"}/>
                </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <MDInput
                            id="AzmayeshDalil"
                            name="AzmayeshDalil"
                            value={formik.values.AzmayeshDalil}
                            onChange={formik.handleChange}
                            error={
                                Boolean(formik.errors.AzmayeshDalil)
                            }
                            helperText={formik.errors.AzmayeshDalil}
                            autoComplete={"1"}
                            disabled={loading}
                            width={"200px"}
                            sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                            label={"علت تجویز آزمایش"}/>
                    </Grid>
                    <Grid item xs={12} md={9} lg={9}>
                        <MDInput
                            id="AzmayeshTafsir"
                            name="AzmayeshTafsir"
                            value={formik.values.AzmayeshTafsir}
                            onChange={formik.handleChange}
                            error={
                                Boolean(formik.errors.AzmayeshTafsir)
                            }
                            helperText={formik.errors.AzmayeshTafsir}
                            autoComplete={"1"}
                            disabled={loading}
                            width={"200px"}
                            sx={{width: {xs: "100%", md: "100%", lg: "97%",}}}
                            label={"تفسیر آزمایش"}/>
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                        <MDInput
                            id="AzmayeshAlt"
                            name="AzmayeshAlt"
                            value={formik.values.AzmayeshAlt}
                            onChange={formik.handleChange}
                            error={
                                Boolean(formik.errors.AzmayeshAlt)
                            }
                            helperText={formik.errors.AzmayeshAlt}
                            autoComplete={"1"}
                            disabled={loading}
                            width={"200px"}
                            sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                            label={"ALT"}/>
                    </Grid>
                    <Grid item xs={12} md={6} lg={4}>
                        <MDInput
                            id="AzmayeshAST"
                            name="AzmayeshAST"
                            value={formik.values.AzmayeshAST}
                            onChange={formik.handleChange}
                            error={
                                Boolean(formik.errors.AzmayeshAST)
                            }
                            helperText={formik.errors.AzmayeshAST}
                            autoComplete={"1"}
                            disabled={loading}
                            width={"200px"}
                            sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                            label={"AST"}/>
                    </Grid>
                    <Grid item xs={12} md={6} lg={4}>
                        <MDInput
                            id="AzmayeshGGT"
                            name="AzmayeshGGT"
                            value={formik.values.AzmayeshGGT}
                            onChange={formik.handleChange}
                            error={
                                Boolean(formik.errors.AzmayeshGGT)
                            }
                            helperText={formik.errors.AzmayeshGGT}
                            autoComplete={"1"}
                            disabled={loading}
                            width={"200px"}
                            sx={{width: {xs: "100%", md: "100%", lg: "93%",}}}
                            label={"GGT"}/>
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <MDInput
                            id="PrevBimary"
                            name="PrevBimary"
                            value={formik.values.PrevBimary}
                            onChange={formik.handleChange}
                            error={
                                Boolean(formik.errors.PrevBimary)
                            }
                            helperText={formik.errors.PrevBimary}
                            autoComplete={"1"}
                            disabled={loading}
                            width={"200px"}
                            sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                            label={"بیماری های قبلی"}/>
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <MDInput
                            id="Hasasiat"
                            name="Hasasiat"
                            value={formik.values.Hasasiat}
                            onChange={formik.handleChange}
                            error={
                                Boolean(formik.errors.Hasasiat)
                            }
                            helperText={formik.errors.Hasasiat}
                            autoComplete={"1"}
                            disabled={loading}
                            width={"200px"}
                            sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                            label={"حساسیت ها"}/>
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <MDInput
                            id="Hdl"
                            name="Hdl"
                            value={formik.values.Hdl}
                            onChange={formik.handleChange}
                            error={
                                Boolean(formik.errors.Hdl)
                            }
                            helperText={formik.errors.Hdl}
                            autoComplete={"1"}
                            disabled={loading}
                            width={"200px"}
                            sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                            label={"HDL"}/>
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <MDInput
                            id="Triglycerides"
                            name="Triglycerides"
                            value={formik.values.Triglycerides}
                            onChange={formik.handleChange}
                            error={
                                Boolean(formik.errors.Triglycerides)
                            }
                            helperText={formik.errors.Triglycerides}
                            autoComplete={"1"}
                            disabled={loading}
                            width={"200px"}
                            sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                            label={"Triglycerides"}/>
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <MDInput
                            id="TCholestrol"
                            name="TCholestrol"
                            value={formik.values.TCholestrol}
                            onChange={formik.handleChange}
                            error={
                                Boolean(formik.errors.TCholestrol)
                            }
                            helperText={formik.errors.TCholestrol}
                            autoComplete={"1"}
                            disabled={loading}
                            width={"200px"}
                            sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                            label={"Total cholestrol"}/>
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <MDInput
                            id="Lholestrol"
                            name="Lholestrol"
                            value={formik.values.Lholestrol}
                            onChange={formik.handleChange}
                            error={
                                Boolean(formik.errors.Lholestrol)
                            }
                            helperText={formik.errors.Lholestrol}
                            autoComplete={"1"}
                            disabled={loading}
                            width={"200px"}
                            sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                            label={"LDL cholestrol"}/>
                    </Grid>
                    <Grid item xs={12} md={6} lg={6}>
                        <MDInput
                            id="BimaryHistory"
                            name="BimaryHistory"
                            value={formik.values.BimaryHistory}
                            onChange={formik.handleChange}
                            error={
                                Boolean(formik.errors.BimaryHistory)
                            }
                            helperText={formik.errors.BimaryHistory}
                            autoComplete={"1"}
                            disabled={loading}
                            width={"200px"}
                            sx={{width: {xs: "100%", md: "100%", lg: "96%",}}}
                            label={"توضیحات سوابق بستری"}/>
                    </Grid>
                    <Grid container justifyItems={"center"} alignItems={"center"} gap={2} item xs={12} md={12} lg={12}>
                        <MDTypography fontWeight={"bold"}>
                            تاریخچه واکسیناسیون
                        </MDTypography>
                        <IconButton color={"info"} onClick={() => addVaksan()}>
                            <AddCircleOutlineOutlinedIcon/>
                        </IconButton>
                    </Grid>
                    {formik.values.Vaksan && formik.values.Vaksan.length > 0 && formik.values.Vaksan.map((e, i) => {
                        return (
                            <React.Fragment key={e.id}>
                                <Grid item xs={12} md={4} lg={4}>
                                    <MDInput
                                        id={`Vaksan.${i}.VaksanKind`}
                                        name={`Vaksan.${i}.VaksanKind`}
                                        value={formik.values.Vaksan[i].VaksanKind}
                                        onChange={formik.handleChange}
                                        error={
                                            Boolean(formik.errors.Vaksan && formik.errors.Vaksan[i] && formik.errors.Vaksan[i].VaksanKind)
                                        }
                                        helperText={formik.errors.Vaksan && formik.errors.Vaksan[i] && formik.errors.Vaksan[i].VaksanKind}
                                        autoComplete={"1"}
                                        disabled={loading}
                                        width={"200px"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "96%",}}}
                                        label={"نوع واکسن "}/>
                                </Grid>
                                <Grid item xs={12} md={4} lg={4}>
                                    <MDDate

                                        name={`Vaksan.${i}.VaksanDate`}
                                        onChange={(r) =>
                                            formik.setFieldValue(`Vaksan.${i}.VaksanDate`, r)
                                        }
                                        defaultValue={formik.values.Vaksan[i].VaksanDate}
                                        label={("تاریخ واکسن")}
                                        error={
                                            Boolean(formik.errors.Vaksan && formik.errors.Vaksan[i] && formik.errors.Vaksan[i].VaksanDate)
                                        }
                                        helperText={formik.errors.Vaksan && formik.errors.Vaksan[i] && formik.errors.Vaksan[i].VaksanDate}

                                        portal

                                        w={{xs: "100%", md: "100%", lg: "90%",}}

                                        disabled={loading}
                                    />
                                </Grid>
                                <Grid container item xs={12} md={4} lg={4}>
                                    <MDInput
                                        id={`Vaksan.${i}.VaksanAvarez`}
                                        name={`Vaksan.${i}.VaksanAvarez`}
                                        value={formik.values.Vaksan[i].VaksanAvarez}
                                        onChange={formik.handleChange}
                                        error={
                                            Boolean(formik.errors.Vaksan && formik.errors.Vaksan[i] && formik.errors.Vaksan[i].VaksanAvarez)
                                        }
                                        helperText={formik.errors.Vaksan && formik.errors.Vaksan[i] && formik.errors.Vaksan[i].VaksanAvarez}
                                        autoComplete={"1"}
                                        disabled={loading}
                                        width={"200px"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "85%",}}}
                                        label={"عوارض واکسن "}/>
                                    <IconButton color={"error"}
                                                onClick={() => formik.setFieldValue("Vaksan", formik.values.Vaksan.filter(p => p.id != formik.values.Vaksan[i].id))}>
                                        <RemoveCircleOutlineOutlinedIcon/>
                                    </IconButton>
                                </Grid>

                            </React.Fragment>
                        )
                    })}
                    <Grid container justifyItems={"center"} alignItems={"center"} gap={2} item xs={12} md={12} lg={12}>
                        <MDTypography fontWeight={"bold"}>
                            داروهای مصرفی
                        </MDTypography>
                        <IconButton color={"info"} onClick={() => addDaroo()}>
                            <AddCircleOutlineOutlinedIcon/>
                        </IconButton>
                    </Grid>
                    {formik.values.Daroo && formik.values.Daroo.length > 0 && formik.values.Daroo.map((e, i) => {
                        return (
                            <React.Fragment key={e.id}>
                                <Grid item xs={12} md={6} lg={3}>
                                    <MDInput
                                        id={`Daroo.${i}.DarooName`}
                                        name={`Daroo.${i}.DarooName`}
                                        value={formik.values.Daroo[i].DarooName}
                                        onChange={formik.handleChange}
                                        error={
                                            Boolean(formik.errors.Daroo && formik.errors.Daroo[i] && formik.errors.Daroo[i].DarooName)
                                        }
                                        helperText={formik.errors.Daroo && formik.errors.Daroo[i] && formik.errors.Daroo[i].DarooName}
                                        autoComplete={"1"}
                                        disabled={loading}
                                        width={"200px"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "96%",}}}
                                        label={"نام دارو"}/>
                                </Grid>
                                <Grid item xs={12} md={6} lg={3}>
                                    <MDInput
                                        id={`Daroo.${i}.DarooZaman`}
                                        name={`Daroo.${i}.DarooZaman`}
                                        value={formik.values.Daroo[i].DarooZaman}
                                        onChange={formik.handleChange}
                                        error={
                                            Boolean(formik.errors.Daroo && formik.errors.Daroo[i] && formik.errors.Daroo[i].DarooZaman)
                                        }
                                        helperText={formik.errors.Daroo && formik.errors.Daroo[i] && formik.errors.Daroo[i].DarooZaman}
                                        autoComplete={"1"}
                                        disabled={loading}
                                        width={"200px"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "96%",}}}
                                        label={"زمان مصرف دارو"}/>
                                </Grid>

                                <Grid item xs={12} md={6} lg={3}>
                                    <MDInput
                                        id={`Daroo.${i}.DarooGhat`}
                                        name={`Daroo.${i}.DarooGhat`}
                                        value={formik.values.Daroo[i].DarooGhat}
                                        onChange={formik.handleChange}
                                        error={
                                            Boolean(formik.errors.Daroo && formik.errors.Daroo[i] && formik.errors.Daroo[i].DarooGhat)
                                        }
                                        helperText={formik.errors.Daroo && formik.errors.Daroo[i] && formik.errors.Daroo[i].DarooGhat}
                                        autoComplete={"1"}
                                        disabled={loading}
                                        width={"200px"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "96%",}}}
                                        label={"دلیل قطع مصرف دارو"}/>
                                </Grid>

                                <Grid item xs={12} md={2} lg={2}>
                                    <MDInput
                                        id={`Daroo.${i}.DarooDoz`}
                                        name={`Daroo.${i}.DarooDoz`}
                                        value={formik.values.Daroo[i].DarooDoz}
                                        onChange={formik.handleChange}
                                        error={
                                            Boolean(formik.errors.Daroo && formik.errors.Daroo[i] && formik.errors.Daroo[i].DarooDoz)
                                        }
                                        helperText={formik.errors.Daroo && formik.errors.Daroo[i] && formik.errors.Daroo[i].DarooDoz}
                                        autoComplete={"1"}
                                        disabled={loading}
                                        width={"200px"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "96%",}}}
                                        label={"دوز  و تعداد دارو"}/>
                                </Grid>
                                <IconButton color={"error"}
                                            onClick={() => formik.setFieldValue("Daroo", formik.values.Daroo.filter(p => p.id != formik.values.Daroo[i].id))}>
                                    <RemoveCircleOutlineOutlinedIcon/>
                                </IconButton>

                            </React.Fragment>
                        )
                    })}
                </Grid>
            </Grid>

            <Grid container my={5} justifyContent={"end"}>
                <Grid item xs={2} textAlign={"start"}>
                    <ButtonBase onClick={formik.handleSubmit}
                                sx={{background: "#4F2788", width: "100%", borderRadius: "5px", height: 50}}
                                disabled={loading}
                                type={"submit"}>
                        <MDBox width={"100%"} py={2}>
                            <MDTypography color={"white"} fontWeight={"bold"} fontSize={"20px"}>
                                ثبت
                            </MDTypography>
                        </MDBox>
                    </ButtonBase>

                </Grid>


            </Grid>
        </MDBox>
    </DashboardLayout>
}